<template>
  <gmap-autocomplete @place_changed="setAddresses" @keydown.enter.prevent @input.prevent="setContent">
    <template #default="slotProps">
      <TextField
        :id="id"
        ref="input"
        v-model="content"
        :labelName="labelName"
        :name="name"
        :type="'text'"
        :status="status"
        :placeholder="placeholder"
        :disabled="disabled"
        :required="required"
        :readonly="readonly"
        :maxlength="maxlength"
        :helperText="helperText"
        :iconStatic="iconStatic"
        refName="input"
        @listeners="slotProps.listeners"
        @attrs="slotProps.attrs"
        @blur="$emit('blur')"
      />
    </template>
  </gmap-autocomplete>
</template>

<script lang="ts">
import helperStatus from '../../helpers/status';
import TextField from '../textfield/TextField.vue';

export default {
  name: 'GooglePlacesTextField',
  components: {
    TextField,
  },
  model: {
    prop: 'modelValue',
    event: 'update:modelValue',
  },
  props: {
    labelName: {
      type: String,
      required: true,
      validator(value: String) {
        return !!value;
      },
    },
    id: {
      type: String,
      required: true,
      validator(value: String) {
        return !!value;
      },
    },
    name: {
      type: String,
      default: '',
      required: false,
    },
    status: {
      type: Number as () => helperStatus,
      default: helperStatus.Neutral,
    },
    modelValue: {
      type: String,
      default: '',
      required: false,
    },
    placeholder: {
      type: String,
      default: '',
      required: false,
    },
    disabled: {
      type: Boolean,
      required: false,
    },
    required: {
      type: Boolean,
      required: false,
    },
    readonly: {
      type: Boolean,
      required: false,
    },
    maxlength: {
      type: String,
      default: undefined,
      required: false,
    },
    helperText: {
      type: String,
      default: '',
      required: false,
    },
    iconStatic: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  data(): any {
    return {
      content: this.modelValue,
    };
  },
  watch: {
    content(selectedValue: String) {
      this.$emit('update:modelValue', selectedValue);
    },
    modelValue(valueFromParent: String) {
      this.content = valueFromParent;
    },
  },
  methods: {
    setContent({ target }) {
      this.content = target.value;
      return false;
    },
    setAddresses(placeData) {
      this.$emit('autoCompletedAddresses', placeData);
      return false;
    },
  },
};
</script>
